<div class="flex-row banner" [ngClass]="type">
  <mat-icon class="material-icons">{{ icon }}</mat-icon>
  <span>
    <ng-content></ng-content>
  </span>
</div>
